import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
// MockupBadge removed - no longer showing demo badges

interface BusinessCardProps {
  id: number;
  slug?: string;
  storeName: string;
  ownerName: string;
  location: string;
  description?: string;
  avatarUrl?: string;
  businessType: 'trader' | 'craftsman' | 'hospitality';
  verified?: boolean;
  mockup?: boolean;
}

const BusinessCard: React.FC<BusinessCardProps> = ({
  id,
  slug,
  storeName,
  ownerName,
  location,
  description,
  avatarUrl,
  businessType,
  verified = false,
  mockup = false
}) => {
  // Generate fallback avatar URL using business name
  const fallbackAvatar = `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(storeName)}&backgroundColor=f3f4f6&fontSize=40`;
  
  // Determine the link path based on business type
  const getLinkPath = () => {
    switch (businessType) {
      case 'trader':
        return `/trader/${slug ?? id}`;
      case 'craftsman':
        return `/craftsman/${slug ?? id}`;
      case 'hospitality':
        return `/hospitality/${slug ?? id}`;
      default:
        return `/trader/${slug ?? id}`;
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer overflow-hidden">
      {/* Image section - matches TraderCard */}
      <div className="relative h-40 sm:h-48">
        <img
          src={avatarUrl || fallbackAvatar}
          alt={storeName}
          className="w-full h-full object-cover"
        />
        {verified && (
          <div className="absolute top-3 right-3 bg-blue-600 text-white px-2.5 py-1 rounded-full text-xs sm:text-sm">
            Verified
          </div>
        )}
        {/* Demo badge removed */}
      </div>
      
      {/* Content section - matches TraderCard */}
      <div className="p-4 sm:p-6">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 line-clamp-2">
            {storeName}
          </h3>

        </div>
        <p className="text-gray-600 text-sm sm:text-base mb-2 line-clamp-1">{ownerName}</p>
        <div className="flex items-center text-gray-500 text-xs sm:text-sm mb-2">
          <MapPin className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
          <span className="line-clamp-1">{location}</span>
        </div>
        {description && (
          <p className="mt-2 text-xs text-gray-600 line-clamp-2">
            {description}
          </p>
        )}
        
        {/* More button */}
        <div className="mt-4">
          <Link
            to={getLinkPath()}
            className="inline-block bg-blue-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors w-full text-center"
          >
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BusinessCard;
